import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "../../../_partials/Layout";
import NavBar2 from '../../../../componets/NavBar2';
import minecraftUrls from "../../../../configs/mine_craft/minecraftUrls";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    14: {
      id: 14,
      name: 'Assets',
      icon: 'fa-regular fa-object-group',
      subcategories: [15, 16, 17,18]
    },
    1: {
      id: 1,
      name: 'Content',
      icon: 'fa-solid fa-grip',
      subcategories: [4, 6, 7, 5]
    },
    2: {
      id: 2,
      name: 'Community',
      icon: 'fa-solid fa-layer-group',
      url: minecraftUrls.addonsPath()
    },
    10: {
      id: 10,
      name: 'Users',
      icon: 'fa-solid fa-users',
      url: minecraftUrls.usersPath()
    },
    3: {
      id: 3,
      name: 'Reports',
      icon: 'exclamation-triangle',
      url: minecraftUrls.reportsPath()
    },
    8: {
      id: 8,
      name: 'Helps',
      icon: 'fa-solid fa-circle-question',
      url: minecraftUrls.tipsPath()
    },
    9: {
      id: 9,
      name: 'Youtube Videos',
      icon: 'fa-brands fa-youtube',
      url: minecraftUrls.youtubeVideosPath()
    },
    11: {
      id: 11,
      name: 'Bundles',
      icon: 'fa-brands fa-app-store-ios',
      url: minecraftUrls.bundlesPath()
    },
    12: {
      id: 12,
      name: 'Notifications',
      icon: 'fa-solid fa-paper-plane',
      url: minecraftUrls.notificationsPath()
    },
    13: {
      id: 13,
      name: 'Challenges',
      icon: 'fa-solid fa-ranking-star',
      url: minecraftUrls.challengesPath()
    },

    // COMPONENTS NAV_DROPDOWN
    4: {
      id: 4,
      name: 'Skins',
      url: minecraftUrls.skinsPath()
    },
    5: {
      id: 5,
      name: 'Entities Skins',
      url: minecraftUrls.mainSkinsPath()
    },
    6: {
      id: 6,
      name: 'Maps',
      url: minecraftUrls.worldsPath()
    },
    7: {
      id: 7,
      name: 'Addon Templates',
      url: minecraftUrls.addonTemplatesPath()
    },
    // avatars
    15: {
      id: 15,
      name: 'Avatars',
      url: minecraftUrls.avatarsPath()
    },
    16: {
      id: 16,
      name: 'Banners',
      url: minecraftUrls.bannersPath()
    },
    17: {
      id: 17,
      name: 'Frames',
      url: minecraftUrls.framesPath()
    },
    18: {
      id: 18,
      name: 'Username Styles',
      url: minecraftUrls.usernameStylesPath()
    },
    19: {
      id: 19,
      name: 'Banned IPs',
      icon: 'fa-solid fa-ban',
      url: minecraftUrls.bannedIpsPath()
    },
  };

  const PARENT_PAGE_IDS = [14, 1, 2, 13, 10, 11, 12, 19, 3, 9, 8];
  const PAGE_IDS        = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => pathname.includes(PAGES[id].url));

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PARENT_PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
